
import { Events } from "@/api";
import BookingDeleteDialog from "@/components/events/BookingDeleteDialog.vue";
import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

const namespace = "auth";

@Component({ components: { BookingDeleteDialog } })
export default class TooltipTemplate extends Vue {
  deleteDialogOpen = false;
  deleting = false;

  @Prop({ required: true, default: () => ({}) })
  scheduler!: any;
  @Prop({ required: true, default: () => true })
  isAgendaView!: boolean;
  @Prop({ required: true, default: () => ({}) })
  templateTooltipModel!: any;

  @Getter("getUser", { namespace })
  getUser!: object | null;

  menu = false;
  $vuetify: any;

  get eventBackgroundColor() {
    let color = "";
    if (this.isFailed) {
      color = "#fa8072"; // failed courses color
    } else if (this.isAudit) {
      color = "orange"; // audit color
    } else if (this.isOnlineCourse) {
      color = "#800080"; // online courses color
    }
    return color ? { backgroundColor: color } : {};
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mdAndDown;
  }
  get canDeleteEvent() {
    const currentUser: any = this.getUser;
    const permissionSearch = currentUser.permissions.find(
      (userPermission: string) => userPermission === "delete_event"
    );
    return Boolean(permissionSearch);
  }

  get canEditEvent() {
    const currentUser: any = this.getUser;
    const isPermitted = Boolean(
      currentUser.permissions.find(
        (permission: string) => permission === "edit_event"
      )
    );
    return isPermitted;
  }

  get canManageEvent() {
    const currentUser: any = this.getUser;
    const isPermitted = Boolean(
      currentUser.permissions.find(
        (permission: string) => permission === "manage_event"
      )
    );
    return isPermitted;
  }
  get event() {
    return this.templateTooltipModel.appointmentData;
  }
  get eventStartTime() {
    const eventDate = new Date(this.event.startDate);
    return moment(eventDate).format("HH:mm");
  }
  get eventEndTime() {
    const eventDate = new Date(this.event.endDate);
    return moment(eventDate).format("HH:mm");
  }
  get isAudit() {
    return this.templateTooltipModel.appointmentData.event_type_id == 2;
  }
  get isFailed() {
    return this.templateTooltipModel.appointmentData.delegates_event_failure;
  }
  get isOnlineCourse() {
    return this.templateTooltipModel.appointmentData.event_type_id == 3;
  }
  get blockDeletion() {
    return this.event?.block_deletion || false;
  }
  get currentDate() {
    return this.templateTooltipModel?.targetedAppointmentData?.startDate;
  }
  get hasOfflineQualificationTraining() {
    if (!this.currentDate || !this.event?.offline_trainings?.length)
      return false;
    const inRange = (this.event?.offline_trainings || []).some(
      (session: any) => {
        if (
          moment(this.currentDate).isSameOrAfter(
            moment(session.started_at).startOf("day")
          ) &&
          moment(this.currentDate).isSameOrBefore(moment(session.finished_at))
        ) {
          return true;
        }
        return false;
      }
    );
    return inRange;
  }

  async onEdit() {
    await this.$router.push({
      name: "EditEvent",
      params: { id: this.event.id.toString() }
    });
  }
  async onGrade() {
    await this.$router.push({
      name: "ViewEvent",
      params: { id: this.event.id.toString() }
    });
  }
  async onDelete() {
    this.deleteDialogOpen = true;
  }

  async onDeleteConfirmed(payload: {
    reason: string;
    instructorArrived: boolean | null;
  }) {
    this.deleting = true;
    try {
      await Events.remove(this.event.id, payload);
      this.deleteDialogOpen = false;
      this.$emit("delete", this.event.text);
    } catch (e) {
      const err = e as any;
      await this.$error(err.errors || err);
    } finally {
      this.deleting = false;
    }
  }
}
